export function NavigationIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.404 5.595L6.96 11h4.54a1.5 1.5 0 011.5 1.5v4.54l5.405-11.445zm.408-2.404c1.273-.6 2.598.724 1.997 1.997l-6.953 14.723c-.683 1.448-2.856.96-2.856-.64V13H4.73c-1.602 0-2.089-2.173-.64-2.856L18.811 3.19z"
      ></path>
    </svg>
  );
}
